export default __webpack_public_path__ + "locales/ru/InviteDialog.json?hash=5ecdd46905ba6fdd6b2a2c5b018820f6";